export default[
    {
        path: '/reportes',
        component: () => import(/* webpackChunkName: "reportes" */ '@/views/Reportes.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_REPORTES'],
        },
        children:[
            {
                path:'main',
                name:'reporteMain',
                component: () => import(/* webpackChunkName: "reporteMain" */ '@/views/reportes/ReportesGraficas.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_REPORTES'],
                },
            },
            {
                path:'tablaventas',
                name:'reporteTablaVentas',
                component: () => import(/* webpackChunkName: "reporteTablaVentas" */ '@/views/reportes/TablaIngresos.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_REPORTES'],
                },
            },
            {
                path:'tablaegresos',
                name:'reporteEgresos',
                component: () => import(/* webpackChunkName: "reporteEgresos" */ '@/views/reportes/TablaEgresos.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_REPORTES'],
                },
            },
            {
                path:'interna',
                name:'reporteInternamientos',
                component: () => import(/* webpackChunkName: "reporteInternamientos" */ '@/views/reportes/ReporteInternamientosDia.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_REPORTES'],
                },
            },
        ],
    },
]